import React, { FC, HTMLAttributes } from 'react';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Root, TagImage } from './Tags.styled';

/**
 * 상품 태그 컴포넌트 (무료배송, 브랜드 등)
 */
export const Tags: FC<React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = (props) => {
  const { badge_list } = useProductCardContext();

  if (!badge_list?.length) {
    return null;
  }

  return (
    <Root {...props}>
      {badge_list.map(({ image_url }) => (
        <TagImage key={image_url} src={image_url} />
      ))}
    </Root>
  );
};
